import { baseApi } from '@/features/api/baseApi';
import directus from '@/features/api/directus';
import type { CustomDirectusTypes } from '@/models/types';
import { readSettings, type DirectusSettings } from '@directus/sdk';

const serverInfoApi = baseApi
  .enhanceEndpoints({
    addTagTypes: ['serverInfo'],
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: builder => ({
      getServerInfo: builder.query<DirectusSettings<CustomDirectusTypes>, void>({
        queryFn: async () => {
          try {
            const data = (await directus.request(
              readSettings(),
            )) as DirectusSettings<CustomDirectusTypes>;
            return { data };
          } catch (error: any) {
            return { error };
          }
        },
        providesTags: ['serverInfo'],
        keepUnusedDataFor: 3600, // 1 hour
      }),
    }),
  });

export const { useGetServerInfoQuery } = serverInfoApi;
